import { CROSSHAIR_CONFIG } from '../utils/Constants.js';

/**
 * Crosshair overlay for precise placement in 360° scenes
 */
export class CrosshairOverlay {
    constructor() {
        this.element = null;
        this.isVisible = false;
        this.createElement();
    }

    /**
     * Create the crosshair DOM element
     */
    createElement() {
        this.element = document.createElement('div');
        this.element.id = 'crosshair-overlay';
        this.element.style.cssText = `
            position: fixed;
            top: 50%;
            left: 50%;
            width: ${CROSSHAIR_CONFIG.SIZE}px;
            height: ${CROSSHAIR_CONFIG.SIZE}px;
            transform: translate(-50%, -50%);
            pointer-events: none;
            z-index: 1000;
            opacity: ${CROSSHAIR_CONFIG.OPACITY};
            display: none;
        `;
        
        // Create crosshair lines with outline using CSS
        this.element.innerHTML = `
            <!-- Horizontal line with outline -->
            <div style="
                position: absolute;
                top: 50%;
                left: 0;
                right: 0;
                height: ${CROSSHAIR_CONFIG.THICKNESS + (CROSSHAIR_CONFIG.OUTLINE_THICKNESS * 2)}px;
                background-color: ${CROSSHAIR_CONFIG.OUTLINE_COLOR};
                transform: translateY(-50%);
            "></div>
            <div style="
                position: absolute;
                top: 50%;
                left: ${CROSSHAIR_CONFIG.OUTLINE_THICKNESS}px;
                right: ${CROSSHAIR_CONFIG.OUTLINE_THICKNESS}px;
                height: ${CROSSHAIR_CONFIG.THICKNESS}px;
                background-color: ${CROSSHAIR_CONFIG.COLOR};
                transform: translateY(-50%);
            "></div>
            
            <!-- Vertical line with outline -->
            <div style="
                position: absolute;
                left: 50%;
                top: 0;
                bottom: 0;
                width: ${CROSSHAIR_CONFIG.THICKNESS + (CROSSHAIR_CONFIG.OUTLINE_THICKNESS * 2)}px;
                background-color: ${CROSSHAIR_CONFIG.OUTLINE_COLOR};
                transform: translateX(-50%);
            "></div>
            <div style="
                position: absolute;
                left: 50%;
                top: ${CROSSHAIR_CONFIG.OUTLINE_THICKNESS}px;
                bottom: ${CROSSHAIR_CONFIG.OUTLINE_THICKNESS}px;
                width: ${CROSSHAIR_CONFIG.THICKNESS}px;
                background-color: ${CROSSHAIR_CONFIG.COLOR};
                transform: translateX(-50%);
            "></div>
        `;
        
        document.body.appendChild(this.element);
        console.log('✅ Crosshair overlay created');
    }

    /**
     * Show the crosshair
     */
    show() {
        if (this.element) {
            this.element.style.display = 'block';
            this.isVisible = true;
            console.log('🎯 Crosshair shown');
        }
    }

    /**
     * Hide the crosshair
     */
    hide() {
        if (this.element) {
            this.element.style.display = 'none';
            this.isVisible = false;
            console.log('🎯 Crosshair hidden');
        }
    }

    /**
     * Check if crosshair is visible
     * @returns {boolean}
     */
    isCrosshairVisible() {
        return this.isVisible;
    }

    /**
     * Update crosshair position (if needed for dynamic positioning)
     * @param {number} x - X position (0-1, center of screen)
     * @param {number} y - Y position (0-1, center of screen)
     */
    updatePosition(x = 0.5, y = 0.5) {
        if (this.element) {
            this.element.style.left = `${x * 100}%`;
            this.element.style.top = `${y * 100}%`;
        }
    }

    /**
     * Remove the crosshair from DOM
     */
    dispose() {
        if (this.element && this.element.parentNode) {
            this.element.parentNode.removeChild(this.element);
            this.element = null;
            console.log('✅ Crosshair overlay disposed');
        }
    }
}
